import React from 'react';
import { useAppContext } from '../../apps/AppContext';
import { CurrencyList } from '../../../DS-Files';

interface CurrencyNumberOutputProps {
    amount?: number;
    currencyId?: string;
    currencySymbol?: string;
    className?: string;
    showZeroAsHyphen?: boolean;
}

export const CurrencyNumberOutput: React.FC<CurrencyNumberOutputProps> = ({ 
    amount = 0, 
    currencyId, 
    currencySymbol, 
    className,
    showZeroAsHyphen = false
}) => {
    const { bizMaster, getLocale } = useAppContext();
    
    // Extract ISO currency code from currencyId (handle formats like "INR-India Rupee" or just "INR")
    const extractCurrencyCode = (id?: string): string => {
        if (!id) return bizMaster?.bizDetails?.currency || 'USD';
        // If currencyId contains a hyphen, take only the part before it
        const code = id.split('-')[0].trim();
        // Validate it's a 3-letter code, otherwise fallback to biz currency
        return code.length === 3 ? code : bizMaster?.bizDetails?.currency || 'USD';
    };
    
    const currency = extractCurrencyCode(currencyId);
    const currSymbol = currencySymbol || CurrencyList.find(currency => currency.currencyID === bizMaster?.bizDetails?.currency)?.symbol || '';
    const locale = getLocale();

    // Show hyphen if amount is zero and showZeroAsHyphen is true
    if (showZeroAsHyphen && (amount === 0 || amount === null || amount === undefined)) {
        return (
            <span className={`d-block ${className}`}>
                -
            </span>
        );
    }

    // Format the amount with currency and thousand separator
    const formattedAmount = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount);

    return (
        <span className={`d-block ${className}`}>
            {formattedAmount}
        </span>
    );
};